// Supply the metadata consumed by existing order screens without treating a Magic
// merchant ID as a legacy POS merchant ID.
const withLegacyFallback = (magic, legacy) => ({
	...legacy,
	...Object.fromEntries(Object.entries(magic ?? {}).filter(([, value]) => value != null)),
});

export const normalizeOrderMerchant = order => {
	if (!order) return order;
	const output = {...order};
	if (getOrderMerchantIdentity(order).source === 'magic') {
		const merchant = order.Merchant;
		const magicMerchant = order.MagicMerchant;
		output.Merchant = {
			...merchant,
			magicMerchantId: magicMerchant?.id ?? merchant?.magicMerchantId ?? order.merchantId,
			locationId: magicMerchant?.locationId ?? merchant?.locationId,
			Platform: withLegacyFallback(magicMerchant?.MagicPlatform, merchant?.Platform),
			Brand: withLegacyFallback(magicMerchant?.MagicBrand, merchant?.Brand),
		};
	}
	if (order.merchantOrder) output.merchantOrder = normalizeOrderMerchant(order.merchantOrder);
	return output;
};

export const getOrderMerchantIdentity = order => {
	const isMagic = (order != null && Object.prototype.hasOwnProperty.call(order, 'MagicMerchant')) || order?.isMagicOrder === true;
	return {
		source: isMagic ? 'magic' : 'legacy',
		merchantId: isMagic
			? order?.MagicMerchant?.id ?? order?.merchantId ?? order?.Merchant?.magicMerchantId
			: order?.Merchant?.id ?? order?.merchantId,
	};
};

export const isSameOrderMerchant = (order, otherOrder) => {
	const identity = getOrderMerchantIdentity(order);
	const otherIdentity = getOrderMerchantIdentity(otherOrder);
	return identity.merchantId != null && otherIdentity.merchantId != null
		&& identity.source === otherIdentity.source
		&& String(identity.merchantId) === String(otherIdentity.merchantId);
};
